export default "/images/94cbfcf342dc590d49d56cc97883680d.jpg";